export const getHtmlElementTopPosition = elementId => {
  const section = document.querySelector(elementId);
  if (section) return section.getBoundingClientRect().top;
  return;
};
